import { createFileRoute } from "@tanstack/react-router";
import {
  TeamManagementPage,
  type TeamManagementTab,
} from "@client/components/admin/team/team-management-page";

function isValidTeamTab(v: unknown): v is TeamManagementTab {
  return (
    v === "members" ||
    v === "departments" ||
    v === "roles" ||
    v === "invites" ||
    v === "approvals"
  );
}

export const Route = createFileRoute("/_app/tenant-settings/users")({
  validateSearch: (search: Record<string, unknown>) => ({
    tab: isValidTeamTab(search.tab) ? search.tab : "members",
  }),
  component: TeamManagementRoutePage,
});

function TeamManagementRoutePage() {
  const { tab } = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <TeamManagementPage
      activeTab={tab}
      onActiveTabChange={(nextTab) =>
        navigate({ search: { tab: nextTab } })
      }
    />
  );
}
